import { useRef } from 'react'

export default function useTimeout(config?: { callback: () => void; delay: number }) {
  const timeoutId = useRef<NodeJS.Timeout>(undefined)

  const cancel = () => {
    clearTimeout(timeoutId.current)
  }

  const wait = (overrideDelay = config!.delay) => {
    cancel()
    timeoutId.current = setTimeout(config!.callback, overrideDelay)
  }

  const start = () => {
    cancel()
    config!.callback()
    wait()
  }

  return config ? { cancel, wait, start } : null
}
